var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeenAgePopupIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 103,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#TeenAgePopupIcon_svg__clip0_1752_21303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 103c25.405 0 46-20.595 46-46s-20.595-46-46-46-46 20.595-46 46 20.595 46 46 46z",
    fill: "#E6F0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.955 42.558s-8.173 12.318-.368 18.48c6.355 5.015 14.848 3.103 18.64-1.174 3.794-4.277.098-15.072-2.733-18.025-4.736-.61-15.54.72-15.54.72z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.19 57.363s1.227 6.83-1.022 8.811c-2.47 1.54-4.032 1.212-4.032 1.212l5.494 4.24 4.954.716 4.274-2.644 2.463-3.25s-2.794.386-4.17-1.596c-1.376-1.982-.343-7.848-.343-7.848l-7.618.36v-.001zM61.653 54.55c.79-1.415.45-3.11-.76-3.785-1.21-.675-2.831-.076-3.621 1.34-.79 1.414-.45 3.109.76 3.784 1.21.675 2.831.076 3.621-1.34z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.411 52.982s1.094-1.74 2.58-.657l-2.58.657z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.411 52.982s1.094-1.74 2.58-.657",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.237 52.093s.278 1.488-.704 2.552l.704-2.552z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.237 52.093s.278 1.488-.704 2.552",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.74 55.282c1.262-.57 1.745-2.23 1.077-3.707-.668-1.477-2.232-2.211-3.495-1.64-1.262.57-1.745 2.23-1.077 3.707.668 1.477 2.232 2.211 3.495 1.64z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.605 52.357s-.944-1.828-2.516-.872l2.516.872z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.605 52.357s-.944-1.828-2.516-.872",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.863 51.317s-.403 1.46.485 2.603l-.485-2.603z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.863 51.317s-.403 1.46.485 2.603",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.081 49.348s1.271 12.257 7.637 12.526c7.458.315 8.75-13.838 8.75-13.838l-.926-.72-4.964-4.077-7.094-1.535s-2.466 3.09-3.403 7.644z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.458 44.281s4.186 6.422 11.65 6.189c2.033-2.502 1.673-11.403-7.408-11.734-9.082-.33-11.093 6.261-8.544 11.193 2.63-1.58 4.302-5.648 4.302-5.648z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.541 49.988s2.572-1.966 4.58-.17c2.008 1.797.038 5.783.038 5.783l1.389 1.023",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.541 49.988s2.572-1.966 4.58-.17c2.008 1.797.038 5.783.038 5.783l1.389 1.023",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.535 49.474s1.837-1.343 5.384.227M48.92 51.501s-2.072-1.614-3.866.138M56.033 51.413s-2.096-1.603-3.866.139",
    stroke: "#333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.058 56.773a.774.774 0 100-1.548.774.774 0 000 1.547zM42.828 56.086a.774.774 0 100-1.547.774.774 0 000 1.547z",
    fill: "#FFE36B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.662 63.12L35.46 43.053 27.95 22.06S26.404 8.09 24.393 7.603c-2.012-.487-.1 6.049-.1 6.049l-2.542-3.83S17.258 2.397 16.2 2.698c-1.057.301 3.383 8.493 3.383 8.493s-5.61-6.907-6.595-6.28c-.986.627 4.99 7.74 4.99 7.74s-5.948-4.42-6.89-3.659c-.942.762 5.996 6.289 5.996 6.289s-5.411-2.93-5.882-1.77c-.263.644 2.794 2.306 5.27 4.434 1.925 1.657 2.816 3.827 5.933 4.54 0 0 5.128 16.737 6.435 22.42 1.195 5.182 3.668 20.955 3.668 20.955l7.152-2.74.002-.002z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.317 14.13s-.234 4.657 2.586 5.901l-2.586-5.901z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.317 14.13s-.234 4.657 2.586 5.901",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.982 61.3l1.082-20.472 4.209-21.894s-.613-14.041 1.3-14.831c1.914-.79 1.025 5.963 1.025 5.963l1.926-4.175S75.829-2.133 76.92-2c1.09.135-2.043 8.91-2.043 8.91s4.487-7.684 5.555-7.216c1.07.467-3.749 8.412-3.749 8.412s5.202-5.28 6.249-4.671c1.047.61-4.964 7.133-4.964 7.133s4.899-3.723 5.543-2.651c.357.597-2.407 2.705-4.529 5.19-1.65 1.93-2.199 4.211-5.17 5.393 0 0-2.505 17.326-2.929 23.141-.387 5.305-.418 21.27-.418 21.27l-7.487-1.614.004.002z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.623 10.234s.946 4.566-1.652 6.23l1.652-6.23z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.623 10.234s.946 4.566-1.652 6.23",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.3 62.914s7.429 9.724 14.941.49c2.968-5.916 4.74-12.383 4.74-12.383l11.027.802-5.248 22.54 5.443 33.633s-23.656 8.853-40.13 1.882c.213-14.439.19-32.975.19-32.975l-7.255-20.458 11.761-4.11 4.53 10.58h.001z",
    fill: "#FDB022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.486 77.212c-.241-2.062-1.89-3.566-3.685-3.356-1.338.156-2.374 1.22-2.72 2.605a.092.092 0 01-.17.02c-.654-1.27-1.909-2.066-3.247-1.91-1.794.21-3.055 2.051-2.813 4.114.145 1.241.802 2.276 1.691 2.86l5.452 4.255a.128.128 0 00.179-.021l4.326-5.396c.731-.774 1.13-1.933.987-3.174v.003z",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.03 43.048a4.323 4.323 0 100-8.645 4.323 4.323 0 000 8.645z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.362 57.676s1.499.971 2.73-.116l-2.73.116z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.362 57.676s1.499.971 2.73-.116",
    stroke: "#333",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.417 51.114c0 .368-.245.665-.548.665-.303 0-.548-.297-.548-.665 0-.367.214-.325.506-.406.307-.084.592.038.592.406h-.002zM47.84 51.305c0 .367-.246.665-.549.665-.303 0-.548-.297-.548-.665 0-.368.24-.53.548-.434.289.09.548.066.548.434z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.938 61.071a.503.503 0 00-.73.028l-.707.784a.438.438 0 00.023.602c.164.165.43.179.602.023l.784-.707a.503.503 0 00.028-.73zm2.59 4.483a.503.503 0 00-.646-.341l-1.006.326a.437.437 0 00-.28.53.436.436 0 00.507.32l1.035-.218a.502.502 0 00.39-.617zm0 5.176a.502.502 0 00-.39-.617l-1.035-.219a.436.436 0 00-.507.32c-.06.224.06.46.28.531l1.006.326a.503.503 0 00.646-.341zm-2.59 4.483a.503.503 0 00-.028-.73l-.784-.707a.438.438 0 00-.602.023.438.438 0 00-.023.602l.707.784a.503.503 0 00.73.028zm-4.483 2.59a.503.503 0 00.342-.647l-.326-1.006a.438.438 0 00-.532-.28.436.436 0 00-.32.508l.219 1.034c.06.283.338.466.617.391zm-5.176 0a.502.502 0 00.617-.39l.219-1.035a.436.436 0 00-.32-.507.436.436 0 00-.531.28l-.326 1.005a.504.504 0 00.341.647zm-3.752-2.618a.504.504 0 01-.731.028.504.504 0 01.028-.73l.784-.707a.438.438 0 01.602.023c.165.164.179.43.024.602l-.707.784zm-3.32-4.455c.074.28.37.43.646.341l1.006-.326a.438.438 0 00.28-.53.437.437 0 00-.507-.32l-1.035.218a.502.502 0 00-.39.617zm0-5.176a.502.502 0 00.39.617l1.035.219a.437.437 0 00.507-.32.438.438 0 00-.28-.531l-1.006-.326a.504.504 0 00-.647.341zm2.589-4.483a.504.504 0 00.028.73l.784.707a.438.438 0 00.602-.023.438.438 0 00.024-.602l-.707-.784a.504.504 0 00-.731-.028zm4.142-1.943a.504.504 0 01.341-.647.502.502 0 01.617.39l.219 1.035a.436.436 0 01-.32.507.436.436 0 01-.531-.28l-.326-1.005zm5.517-.647a.503.503 0 00-.617.39l-.219 1.035a.436.436 0 00.32.507c.224.06.46-.06.532-.28l.326-1.005a.503.503 0 00-.342-.647z",
    fill: "#0063A8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.449,
    cy: 50.459,
    r: 3.274,
    transform: "rotate(-45 7.449 50.459)",
    stroke: "#005392",
    strokeWidth: 4,
    strokeDasharray: "1.5 10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 11,
    r: 7.192,
    transform: "rotate(-45 56 11)",
    stroke: "#005392",
    strokeWidth: 4,
    strokeDasharray: "1.5 20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "TeenAgePopupIcon_svg__clip0_1752_21303"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v103H0z"
  })))));
}
export default __webpack_public_path__ + "static/TeenAgePopupIcon.9deb77cc.svg";
export { SvgTeenAgePopupIcon as ReactComponent };